import React, { useEffect, useState } from 'react';
import { TartaWordmark } from './TartaWordmark';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navLeft = [{
    label: t.header.navCheesecake,
    href: '#product'
  }, {
    label: t.header.navOccasions,
    href: '#flavors'
  }];
  const navRight = [{
    label: t.header.navEnquiries,
    href: '#about'
  }, {
    label: t.header.navFaq,
    href: '#faq'
  }, {
    label: t.header.navReserve,
    href: '#preorder'
  }];
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const LangToggle = ({
    className = ''
  }: {
    className?: string;
  }) => <div className={`flex items-center text-[10px] tracking-[0.3em] uppercase ${className}`} data-id="element-149" data-mp="3f9dqgjzi6pkq">
      <button onClick={() => setLang('en')} className={`transition-colors duration-300 ${lang === 'en' ? 'text-caramel' : 'text-cream/40 hover:text-cream/70'}`} aria-label="Switch to English" aria-pressed={lang === 'en'} data-id="element-150" data-mp="2rlrjpg6fbp1h">
        EN
      </button>
      <span className="mx-2 text-cream/25" data-id="element-151" data-mp="2hpy7jxwm9xk8">/</span>
      <button onClick={() => setLang('es')} className={`transition-colors duration-300 ${lang === 'es' ? 'text-caramel' : 'text-cream/40 hover:text-cream/70'}`} aria-label="Cambiar a Español" aria-pressed={lang === 'es'} data-id="element-152" data-mp="3faar7thnfxsi">
        ES
      </button>
    </div>;
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${scrolled ? 'bg-chocolate/85 backdrop-blur-xl border-b border-cream/5' : 'bg-transparent'}`} data-id="element-153" data-mp="30locntzuja2c">
      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-16 h-24 lg:h-28 flex items-center justify-center" data-id="element-154" data-mp="3ta29w7j422cu">
        {/* Desktop left nav */}
        <nav className="hidden md:flex items-center gap-10 absolute left-6 lg:left-16 top-1/2 -translate-y-1/2" data-id="element-155" data-mp="1rfxikldj5c8c">
          {navLeft.map(link => <a key={link.href} href={link.href} className="text-[10px] tracking-[0.3em] uppercase text-cream/60 hover:text-cream transition-colors duration-500 relative group" data-id="element-156" data-mp="1hmqhvdtqikel">
              {link.label}
              <span className="absolute -bottom-1.5 left-0 w-0 h-px bg-caramel transition-all duration-500 group-hover:w-full" data-id="element-157" data-mp="1cootqehgbuw9" />
            </a>)}
        </nav>

        {/* Mobile hamburger */}
        <button onClick={() => setOpen(!open)} className="md:hidden absolute left-6 top-1/2 -translate-y-1/2 text-cream" aria-label="Toggle menu" data-id="element-158" data-mp="13nqppw70jndo">
          <div className="w-6 flex flex-col gap-1.5" data-id="element-159" data-mp="2y201ua2llhph">
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'rotate-45 translate-y-1.5' : ''}`} data-id="element-160" data-mp="2y0p0si0jeo22" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'opacity-0' : ''}`} data-id="element-161" data-mp="hflc6gzkmvta" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? '-rotate-45 -translate-y-1.5' : ''}`} data-id="element-162" data-mp="w4ptlvyjkw0c" />
          </div>
        </button>

        {/* Centered wordmark */}
        <a href="#top" className="flex flex-col items-center text-cream" data-id="element-163" data-mp="1544m10y9rgnh">
          <TartaWordmark height={22} data-id="element-164" data-mp="106ktcw0tr1c0" />
          <span className="mt-2.5 text-[9px] tracking-[0.4em] uppercase text-cream/50" data-id="element-165" data-mp="105jhipbziat8">
            {t.header.tagline}
          </span>
        </a>

        {/* Desktop right nav + language toggle */}
        <div className="hidden md:flex items-center gap-8 lg:gap-10 absolute right-6 lg:right-16 top-1/2 -translate-y-1/2" data-id="element-166" data-mp="1a4s9xdr7bhdh">
          <nav className="flex items-center gap-8 lg:gap-10" data-id="element-167" data-mp="3gwt3wixu7w14">
            {navRight.map((link, i) => {
            const isReserve = i === navRight.length - 1;
            return <a key={link.href} href={link.href} className={`text-[10px] tracking-[0.3em] uppercase transition-colors duration-500 relative group ${isReserve ? 'text-caramel hover:text-cream' : 'text-cream/60 hover:text-cream'}`} data-id="element-168" data-mp="22yf6jolwzg0g" data-mpi={i}>
                  {link.label}
                  <span className={`absolute -bottom-1.5 left-0 h-px transition-all duration-500 ${isReserve ? 'w-full bg-caramel/50 group-hover:bg-caramel' : 'w-0 bg-caramel group-hover:w-full'}`} data-id="element-169" data-mp="1k8fpnp089784" />
                </a>;
          })}
          </nav>
          <span className="w-px h-3 bg-cream/20" aria-hidden data-id="element-170" data-mp="1xzc6kiksjzzc" />
          <LangToggle data-id="element-171" data-mp="1y1oudcd8d4kb" />
        </div>

        {/* Mobile right — language toggle (Reserve moves to hamburger menu) */}
        <div className="md:hidden absolute right-6 top-1/2 -translate-y-1/2" data-id="element-172" data-mp="15j9t68srxv3x">
          <LangToggle data-id="element-173" data-mp="15h6t0vxwqllh" />
        </div>
      </div>

      {open && <div className="md:hidden bg-chocolate/95 backdrop-blur-xl border-t border-cream/5 px-8 py-8 space-y-5" data-id="element-174" data-mp="xyh1ykiyrdaz">
          {[...navLeft, ...navRight].map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block text-[10px] tracking-[0.3em] uppercase text-cream/80" data-id="element-175" data-mp="oykj4zj998nu">
              {link.label}
            </a>)}
        </div>}
    </header>;
}